import { create } from "zustand"

type LogicStore = {
	hiddenFields: Record<string, boolean>
	setHiddenFields: (fieldId: string, hidden: boolean) => void
	resetHiddenFields: () => void
	errors: Record<string, string>
	setError: (fieldId: string, error: string) => void
	clearError: (fieldId: string) => void
	resetErrors: () => void
	fieldSectionMap: Record<string, number>
	setFieldSectionMap: (indices: Record<string, number>) => void
	sectionFieldCount: number[]
	setSectionFieldCount: (sectionIndex: number, count: number) => void
	updateSectionFieldCount: (sectionIndex: number, delta: number) => void
	resetSectionFieldCount: () => void
	resetFieldSectionMap: () => void
}

export const useLogicStore = create<LogicStore>()(set => ({
	hiddenFields: {},
	setHiddenFields: (id, val) =>
		set(state => ({
			hiddenFields: { ...state.hiddenFields, [id]: val },
		})),
	resetHiddenFields: () => set({ hiddenFields: {} }),
	errors: {},
	setError: (id, val) =>
		set(state => ({
			errors: { ...state.errors, [id]: val },
		})),
	clearError: id =>
		set(state => {
			// Create a shallow copy of current errors
			const newErrors = { ...state.errors }
			// Remove the one we want to clear
			delete newErrors[id]
			return { errors: newErrors }
		}),
	resetErrors: () => set({ errors: {} }),

	fieldSectionMap: {},
	setFieldSectionMap: map => set({ fieldSectionMap: map }),
	sectionFieldCount: [],
	setSectionFieldCount: (sectionIndex, count) =>
		set(state => {
			const updated = [...state.sectionFieldCount]
			updated[sectionIndex] = count
			return { sectionFieldCount: updated }
		}),
	updateSectionFieldCount: (sectionIndex, delta) =>
		set(state => {
			const updated = [...state.sectionFieldCount]
			updated[sectionIndex] = (updated[sectionIndex] || 0) + delta
			return { sectionFieldCount: updated }
		}),

	resetFieldSectionMap: () => set({ fieldSectionMap: {} }),
	resetSectionFieldCount: () => set({ sectionFieldCount: [] }),
}))
